import { usePageNumber } from "../../hooks/usePageNumber";
import { Button } from "../ui/btns/Button";
import NextPageIcon from "../ui/icons/NextPageIcon";
import PreviousPageIcon from "../ui/icons/PrevPageIcon";

export const Pagination = ({pagination}) => {
    const [setPage] = usePageNumber();
    if(!pagination) return null;

    const nextPage = () => {
        let nextPageNum = pagination.currentPage + 1;
        if(nextPageNum > pagination.totalPages) return;
        setPage(nextPageNum);
    }

    const prevPage = () => {
        let prevPageNum = pagination.currentPage - 1;
        if(prevPageNum < 1) return;
        setPage(prevPageNum);
    }

    return (
        <div className="w-full flex justify-between items-center my-8 px-4 sm:px-6">
            <Button onClick={prevPage} disabled={pagination.currentPage <= 1} variant="secondary">
                <PreviousPageIcon />
            </Button>

            <span className="font-heading text-sm font-bold uppercase tracking-wider text-flyers-mid-gray">
                Page {pagination.currentPage} of {pagination.totalPages}
            </span>

            <Button onClick={nextPage} disabled={pagination.currentPage >= pagination.totalPages} variant="secondary">
                <NextPageIcon />
            </Button>
        </div>
    )
}
